import Template41AnswerSummary from 'views/components/taskGroups/tasks/template41/Template41AnswerSummary'
import Template41Svelte from './Template41.svelte';
import {GAP_TYPE} from 'views/components/taskGroups/tasks/template41/GapTextUtil'

export default class Template41 extends BaseView {

    get textToSpeechURL() {
        // Create URL query parameter with the order of each gap type choice option,
        // separated // per gap with a "|" character, such that gap answer options
        // are read in the same order as they appear for the user.
        const gapIndices = this.model.get('task_info_json').text.reduce((m, fragment) => {
            if (fragment instanceof Object && fragment.type === GAP_TYPE.CHOICE) {
                m.push(_.pluck(fragment.answers, 'index').join())
            }
            return m
        }, [])
        return `/tasks/synthesize/${this.model.id}.json?gaps=${gapIndices.join('|')}`
    }

    initialize({
        taskView,
    }) {
        // To use the newer Svelte technology, create a proxy backbone view.
        // which has all the methods of a backbone view, but proxies the most
        // important methods to the svelte view.
        const svelteView = this.addSvelteChildView(
            this.$el,
            Template41Svelte,
            {
                model: this.model,
                response: taskView.response,
                syncResponse: taskView.saveResponse.bind(taskView),
                taskContainerElement: this.el,
            }
        );

        const methodsToProxy = [
            'showAnswer', 'showAuthorAnswer', 'hideAnswer', 'lockAnswer', 'unlockAnswer',
        ]

        for (const method of methodsToProxy) {
            this[method] = svelteView[method].bind(svelteView);
        }
    }

    getCorrectAnswer() {
        return new Template41AnswerSummary({
            model: this.model,
        })
    }

    getStudentAnswer(response) {
        if (response.get('json_answer')) {
            return new Template41AnswerSummary({
                model: this.model,
                response,
            })
        }
        return ''
    }
}
